// Distance: meters → display unit
export const formatDistance = (meters, unit = 'm') => {
  if (unit === 'ft') {
    const feet = meters * 3.28084
    if (feet < 1) return `${Math.round(feet * 12)} in`
    if (feet < 5280) return `${feet.toFixed(1)} ft`
    return `${(feet / 5280).toFixed(2)} mi`
  }
  if (meters < 1) return `${Math.round(meters * 100)} cm`
  if (meters < 1000) return `${meters.toFixed(1)} m`
  return `${(meters / 1000).toFixed(2)} km`
}

// Area: m² → display unit
export const formatArea = (m2, unit = 'm²') => {
  switch (unit) {
    case 'ft²': {
      const ft2 = m2 * 10.7639
      return `${Math.round(ft2).toLocaleString()} ft²`
    }
    case 'ac': {
      const ac = m2 * 0.000247105
      return `${(Math.round(ac * 100) / 100).toLocaleString()} ac`
    }
    case 'm²': {
      if (m2 >= 10000) return `${(m2 / 10000).toFixed(2)} ha`
      return `${Math.round(m2).toLocaleString()} m²`
    }
  }
}

// Mass: kg → display unit
export const toDisplayMass = (kg, unit) =>
  unit === 'lbs' ? Math.round(kg * 2.20462 * 10) / 10 : kg

// Display unit → kg (for saving back to DB)
export const fromDisplayMass = (val, unit) =>
  unit === 'lbs' ? Math.round((val / 2.20462) * 1000) / 1000 : val

// Format a mass value (stored as kg) for display
export const formatMass = (kg, unit = 'kg') => {
  const val = toDisplayMass(kg, unit)
  const suffix = unit === 'lbs' ? 'lbs' : 'kg'
  if (val >= 1000) return `${(val / 1000).toFixed(1)}k ${suffix}`
  return val % 1 === 0 ? `${val} ${suffix}` : `${val.toFixed(1)} ${suffix}`
}
